import React, { useState } from "react"

export default function MainPopup() {
  const [visible, setVisible] = useState(true)
  const handleClick = () => {
    setVisible(!visible)
  }
  return (
    <div>
      {visible ? (
        <div className="w-[25%] z-50 fixed bottom-[1%] left-[1%] max-xl:w-[60%] max-md:w-[90%] max-md:left-[50%] max-md:transform max-md:-translate-x-1/2">
          <div
            className="rounded-2xl border border-blue-100 bg-white p-4 shadow-lg sm:p-6 lg:p-8"
            role="alert"
          >
            <div className="flex items-center gap-2">
              <span className="shrink-0 rounded-full bg-red-400 p-2 text-white">
                <svg
                  className="h-5 w-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M8.257 3.099c.765-1.36 2.721-1.36 3.486 0l6.518 11.591c.75 1.334-.213 2.31-1.743 2.31H3.482c-1.53 0-2.493-.976-1.743-2.31L8.257 3.1zM11 14a1 1 0 10-2 0 1 1 0 002 0zm-1-2a1 1 0 01-1-1V9a1 1 0 012 0v2a1 1 0 01-1 1z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>

              <p className="font-medium sm:text-lg">Refills</p>
            </div>

            <p className="mt-2 text-gray-500 whitespace-pre-line">
              If you need refills or have any other inquiries, please reach out to us at {" "}
              <a 
                href="mailto:annieijs94@gmail.com."
                className="text-blue-500 underline"  
              >annieijs94@gmail.com</a>.
            </p>

            <div className="mt-4 sm:flex sm:gap-4">
              <a
                className="mt-2 inline-block w-full rounded-lg bg-gray-100 px-5 py-3 text-center text-sm font-semibold border border-gray-700 text-gray-700 sm:mt-0 sm:w-auto cursor-pointer"
                onClick={handleClick}
              >
                Mark as Read
              </a>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}
